import { ActionLabels } from '@sbv-clients/util-misc';

import {
  Button,
  Dialog,
  DialogActionsContainer,
  DialogContent,
  DialogHeader,
  printErrorToConsole,
  useToggleModal,
} from '../../index';

export const useConfirmModal = (
  handleConfirm: () => void,
  title: string,
  content: string
) => {
  const { open, openModal, closeModal } = useToggleModal();

  const handleConfirmWithClose = () => {
    try {
      closeModal();
      handleConfirm();
    } catch (e) {
      printErrorToConsole(e);
    }
  };

  const modal = () => {
    return (
      <Dialog open={open} fullWidth>
        <DialogHeader title={title} onClose={closeModal} />
        <DialogContent sx={{ mt: 6 }}>{content}</DialogContent>
        <DialogActionsContainer>
          <Button variant="outlined" onClick={closeModal}>
            {ActionLabels.Cancel}
          </Button>
          <Button variant="contained" onClick={handleConfirmWithClose}>
            {ActionLabels.Confirm}
          </Button>
        </DialogActionsContainer>
      </Dialog>
    );
  };

  return {
    modal,
    openModal,
  };
};
